import { Component, Injector, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { COMMON_CONSTANTS, MANAGE_LINE_CONST } from 'src/app/common/core/common.constants';
import { CommonConfirmationModalComponent } from '../common-confirmation-modal/common-confirmation-modal.component';
import { LoaderService } from 'src/app/services/loader.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { SimChangeComponent } from '../sim-change/sim-change.component';
import { WindowServiceService } from 'src/app/services/window-service.service';

@Component({
  selector: 'app-common-multiline-block-unblock-modal',
  templateUrl: './common-multiline-block-unblock-modal.component.html',
  styleUrls: ['./common-multiline-block-unblock-modal.component.scss']
})
export class CommonMultilineBlockUnblockModalComponent implements OnInit {

  authoringContentData: any;
  action: any;
  body: any;
  header: any;
  footer:any;
  ctaSubmit: any;
  ctaCancel: any;
  actionOn: any;
  actionOff: any;
  selectedLines: any;
  ngbModalOptions: NgbModalOptions;
  requestPayLoad: any ={};
  authInfo: any;
  isActionOn: boolean = null;
  isActionChangeSim: boolean = false;
  loaderSvc: LoaderService;
  isSubmitEnabled: boolean = false;
  _helperUtilSvc: HelperUtilityService;
  simToDeviceLock: boolean;
  _windowService: WindowServiceService;
  confirmationModalAction: string = "";
  confirmationModalCtaClose: string = "";
  confirmationModalHeader: string = "";
  confirmationModalActionMessage: string = "";
  simProtectionSuccessModalMessage: string = "";
  simProtectionSuccessModalHeader: string = "";

  constructor(private injector : Injector, private _cacheSvc: HttpCacheService, private _utilSvc: UtilsService, public manageLineService: ManageLineService,  public utilsSvc: UtilsService, private modalService: NgbModal) {
    this.loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this._windowService = this.injector.get<WindowServiceService>(WindowServiceService);
   }

  ngOnInit(): void {
    if(this.action == "simtoDevice"){
      this.simToDeviceLock = true;
    }

    this.authoringContentData = this._utilSvc.getContentDataFromSession();
      this.selectedLines = this.selectedLines?.map((line) => {
      return {
        ...line,
        isSelected:true,
        portOutRestrictionStatus: line.portOutProtectionClass == "PORT_OUT_PROTECTION_ON" ? this.authoringContentData.manageLine.portOffRestriction:this.authoringContentData.manageLine.portOnRestriction,
        simLockUnlockRestrictionStatus: line.simLockUnlockClass == "SIM_DEVICE_UNLOCK" ? this.authoringContentData.manageLine.simLockRestriction : this.authoringContentData.manageLine.simUnlockRestriction
      };
    });
    if(this.isActionChangeSim) {
      this.isActionOn = false;
      this.isSubmitDisabled();
    }
  }

  onClickSubmit(){
    this.ngbModalOptions = {
      backdrop: "static",
      keyboard: false,
      centered: false,
      container: "#am-container-custom",
    };

    if(this.action === 'simProtection') {
      this.simProtectionFlow();
    } else {
    this.manageLineService.submitBulkRequest(this.requestPayLoad).subscribe({
      next: (data) =>  { 
        this.manageLineService.close();
        this.getContent(data.token);
        const portOutConfirmationModalRef = this.modalService.open(CommonConfirmationModalComponent,this.ngbModalOptions);
          portOutConfirmationModalRef.componentInstance.action = this.confirmationModalAction;
          portOutConfirmationModalRef.componentInstance.ctaClose = this.confirmationModalCtaClose;
          portOutConfirmationModalRef.componentInstance.header = this.confirmationModalHeader;
          portOutConfirmationModalRef.componentInstance.message = this.confirmationModalActionMessage;
       
        portOutConfirmationModalRef.componentInstance.isYesButtonClicked.subscribe((closeButtonClicked)=>{
          this.checkCloseButtonClick(closeButtonClicked);
        });
      },
      error: (err) => {
        this.manageLineService.close();
        this.utilsSvc.errorHandling(err);
      }
    });
  }
  }

  getContent(transactionId){
    if (this.action == "simtoDevice") {
      this.confirmationModalAction = this.authoringContentData.manageLine.portOutProtectionAction;
      this.confirmationModalCtaClose = this.authoringContentData.manageLine.portOutProtectionCompletedCTA;
      this.confirmationModalHeader = this.isActionOn ? this.authoringContentData.manageLine.simLockUnlock.simLockToDeviceCompletedHeader : this.authoringContentData.manageLine.simLockUnlock.simUnlockToDeviceCompletedHeader;
      this.confirmationModalActionMessage = (this.isActionOn ? this.authoringContentData.manageLine.turnOnSimLockUnlockCompletedMessageMulti : this.authoringContentData.manageLine.turnOffSimLockUnlockCompletedMessageMulti).replace('{{transactionId}}', transactionId);
    } else {
      this.confirmationModalAction = this.authoringContentData.manageLine.portOutProtectionAction;
      this.confirmationModalCtaClose = this.authoringContentData.manageLine.portOutProtectionCompletedCTA;
      this.confirmationModalHeader = this.isActionOn ? this.authoringContentData.manageLine.turnOnPortOutProtectionCompletedHeader : this.authoringContentData.manageLine.turnOffPortOutProtectionCompletedHeader;
      this.confirmationModalActionMessage = (this.isActionOn ? this.authoringContentData.manageLine.turnOnPortOutCompletedMessageMulti : this.authoringContentData.manageLine.turnOffPortOutCompletedMessageMulti).replace('{{transactionId}}', transactionId);
    }
  }

  simProtectionFlow() {
    this.loaderSvc.start();
    this.setRequestBodyForSimProtectionIfChangeSimFlow();
    if (this.ctaSubmit === this.authoringContentData.common_authoring.simChangestxt) {
      let lines = this.selectedLines?.filter(item => item.isSelected);
      const SimChangeModalRef = this.modalService.open(SimChangeComponent, this.ngbModalOptions);
      SimChangeModalRef.componentInstance.selectedLines = lines;
    } else {
      this.manageLineService.manageBlockStatus(this.requestPayLoad).subscribe({
        next: (data) => {
          if (!isNullOrUndefined(data) && !isNullOrUndefined(data.status)
            && data.status === 'Success') {
            this.loaderSvc.stop();
            this.manageLineService.close();
            this.getModalTexts(data.accountTransactionRefNum);
            const simProtectionSuccessModalRef = this.modalService.open(CommonConfirmationModalComponent, this.ngbModalOptions);

            simProtectionSuccessModalRef.componentInstance.message = this.simProtectionSuccessModalMessage;
            simProtectionSuccessModalRef.componentInstance.ctaClose = this.authoringContentData.manageLine.closeCTA;
            simProtectionSuccessModalRef.componentInstance.action = true;
            simProtectionSuccessModalRef.componentInstance.header = this.simProtectionSuccessModalHeader;
            simProtectionSuccessModalRef.componentInstance.isYesButtonClicked.subscribe((closeButtonClicked) => {
              this.checkCloseButtonClick(closeButtonClicked);
            });
          } else {
            this.showErrorUtil();
          }
        },
        error: (err) => {
          this.showErrorUtil(err);
        }
      });
    }
  }

  showErrorUtil(err: any = undefined) {
    this.loaderSvc.stop();
    this.manageLineService.close();
    this.utilsSvc.errorHandling(err);
  }

  checkCloseButtonClick(closeButtonClicked : any){
    if (closeButtonClicked) {
      this._windowService.location.reload();
      this.modalService.dismissAll();
    }
  }

  getModalTexts(transId){
    this.simProtectionSuccessModalMessage = this.isActionOn ? this.authoringContentData.manageLine.simProtection.simProtectionMultiOn.completedMessage?.replace('{{transactionId}}', transId) : this.authoringContentData.manageLine.simProtection.simProtectionMultiOff.completedMessage?.replace('{{transactionId}}', transId);
    this.simProtectionSuccessModalHeader = this.isActionOn ? this.authoringContentData.manageLine.simProtection.simProtectionMultiOn.header : this.authoringContentData.manageLine.simProtection.simProtectionMultiOff.header;
    
  }
  
  setRequestBodyForSimProtectionIfChangeSimFlow() {
    if(this.isActionChangeSim) {
      this.onClickAction(false);
    }
  }

  onClickCancel() {
    this.manageLineService.close();
  }

  onClickAction(isOn: boolean) {
    this.isActionOn = isOn;
    this.authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    
    if (this.action === 'simProtection') {
      this.simProtectionRequestPayload(isOn);
    } else {
      const multiRequest = this.generateMultiRequest();
      const targetServiceName = this.getTargetServiceName();
      this.requestPayLoad = {
        targetServiceName,
        requests: multiRequest,
        ban: this.selectedLines[0]?.ban
      };
    }
  
    this.isSubmitDisabled();
  }
  
   generateMultiRequest() {
    return this.selectedLines?.filter(line => line?.isSelected).map(line => ({
      orgId: this._helperUtilSvc.getOrgID(),
      ban: line.ban || '',
      msisdn: line.msisdn || '',
      action: this.getActionForLine(),
      transType: this.getTargetServiceName(),
      logonId: this.authInfo?.logonID || COMMON_CONSTANTS.LOGON_ID,
      email: this.authInfo?.logonEmail || COMMON_CONSTANTS.LOGON_ID
      }));
  }
  
   getActionForLine() {
    if (this.action === 'simtoDevice') {
      return this.isActionOn ? 'LOCK' : 'UNLOCK';
    } else {
      return this.isActionOn ? 'BLOCK' : 'UNBLOCK';
    }
  }
  
  
   getTargetServiceName() {
    return this.action === 'simtoDevice' ? 'manage-sim-device' : 'manage-port-out';
  }
  

  simProtectionRequestPayload(isOn) {
    this.requestPayLoad = {
      "ban": this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN),
      "msisdns": [],
      "transType": "Sim-Swap",
      "action": (isOn) ? "BLOCK" : "UNBLOCK"
    }
    this.selectedLines?.forEach((line) => {
      if(line?.isSelected){
        this.requestPayLoad.msisdns.push(line.msisdn);
      }
    });
  }

  updateSelection(event, line) {
    if (event.checked) {
      line.isSelected = true;
    } else {
      line.isSelected = false;
    }
    this.isChangeSimFlow();
    this.isSubmitDisabled();
  }

  isChangeSimFlow() {
    if (this.isActionChangeSim) {
      this.ctaSubmit = !this.updateSubmitCTA() ? this.authoringContentData.common_authoring.simChangestxt : this.authoringContentData.manageLine.simProtection.simProtectionOff.header;
    }
  }

  updateSubmitCTA(): boolean {
    return this.selectedLines.some(line => line.isSelected && line.simSwap);
  }

  isSubmitDisabled() {
    const linesWithSelection = this.selectedLines?.find((eachLine) => eachLine.isSelected === true);
    if (linesWithSelection && !isNullOrUndefined(this.isActionOn)) {
      this.isSubmitEnabled = true;
    } else {
      this.isSubmitEnabled = false;
    }
  }

}
